<template>
    <div id="content" v-show="!loading">
        <form>
            <div class="inner">
                <p class="paging">
                    <router-link
                            :to="{ name: detailPageRouteName, params: {id: entity.id_cron} }"
                            class="btn btn_back"
                            v-translate>Detail
                    </router-link>
                </p>
                <h1 v-translate>Logy</h1>
            </div>

            <div class="responsiveTabs">
                <div class="tabs_content logs">
                    <p v-html="entity.log"></p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
	import detailActions from "@/components/mixins/detail-actions"

	export default {
		name: "CronRunLog",
		mixins: [detailActions],
		data() {
			return {
				loading: true,
				entityName: 'run',
				moduleName: 'crons',
				detailPageRouteName: 'cronDetailHistory',
			}
		},
		created(CronService) {
			this.entityService = CronService
			this.createdInit()
		},
		methods: {
			getEntity() {
				this.setLoadingMessage()

				return this.entityService.getCronRun(this.$route.params.id, {})
					.then(data => {
						this.emptyMessage()
						this.entity = data[this.entityName]
						this._afterGetEntityActions(data)
					})
					.catch(function (error) {
						this.setErrorMessage(error['error_message'])
					}.bind(this))
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/crons/CronRunLog.vue